import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import common from "../../helper/common";

const initialState = {
    active: false,
    selectedProduct: [],
    loading: 'idle', //'idle' | 'pending' | 'succeeded' | 'failed'
    productDetails: []
}

export const ShopifyProduct = createSlice({
    name: 'ShopifyProduct',
    initialState,
    reducers: {
        updateProductData: (state, action) => {
            if (action.payload.hasOwnProperty('active')) {
                state.active = action.payload.active
            }
            if (action.payload.selectedProduct) {
                console.log(state.selectedProduct)
                state.selectedProduct = action.payload.selectedProduct
            }
        },

        clearData: (state, action) => {
            state.active = false
            state.selectedProduct = []
            state.productDetails = []
            state.loading = 'idle'            
        },

        resetShopifyProduct: (state, action) => {
            console.log('resetting ShopifyProduct slice')
            Object.keys(initialState).forEach((key) => {
                state[key] = initialState[key]
            })
        }
    },
    extraReducers: builder => {
        builder.addCase(fetchProductData.fulfilled, (state, action) => {
            state.loading = 'succeeded'
            console.log(action)
            if(action.payload && action.payload.data) {
                state.productDetails = action.payload.data
            }

        }).addCase(fetchProductData.pending, (state, action) => {
            state.loading = 'pending'
            console.log(action)

        }).addCase(fetchProductData.rejected, (state, action) => {
            state.loading = 'failed'
            console.log(action)
        })
    }
})

export const fetchProductData = createAsyncThunk(
    'product/fetchById', async ({product, customFetch}, {rejectWithValue}) => {
        try {
            const response = await customFetch(`/api/get-selected-products?product=${JSON.stringify(product)}`)
            return await response.json()
        } catch (err) {
            console.log(err)
            return rejectWithValue(err.title)
        }
    }
)

export const { updateProductData, clearData, resetShopifyProduct } = ShopifyProduct.actions

export default ShopifyProduct.reducer